import { SelectionModel } from '@angular/cdk/collections';
import { Component, HostListener, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from "@angular/material/table";
import { constant } from 'src/app/constant/constant';
import { ItemDepartment } from "src/app/models/ItemDepartment";
import { ItemDeptRequest } from 'src/app/models/RequestModel/itemDeptRequest';
import { userAccess } from "src/app/models/UserAccess";
import { ItemDepartmentService } from 'src/app/services/ItemDepartment/item-department.service';
import { UserService } from "src/app/services/User/user.service";
import { UtilityService } from "src/app/services/utility/utility.service";

@Component({
    selector: 'app-department-search',
    templateUrl: './department-search.component.html',
    styleUrls: ['./department-search.component.scss'],
    standalone: false
})

  export class DepartmentSearchComponent implements OnInit {

    // itemDept: any={
    //     DeptCode:"",
    //     DeptName:""
    // }

    itemDept:ItemDeptRequest =new ItemDeptRequest();

    showTableForTransactionReport:boolean=true;
    deptArray: any[] = [];
    userAccessData!: userAccess;
    selection = new SelectionModel<any>(true, []);

    @ViewChild(MatPaginator, { static: false })
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;
    displayedColumns = ['Select', 'DeptCode', 'DeptName'];
    pageSizeOptions: number[] = [10, 25, 50, 100];
    currentPage = 0;
    pageSize = 10;
    totalRows = 0;
    searchKey = "";
    deptDataSource: MatTableDataSource<any> = new MatTableDataSource();

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private itemDeptService:ItemDepartmentService,  private userService: UserService, private utilityService: UtilityService, private deptDialogService: MatDialogRef<DepartmentSearchComponent>,) {
        this.userAccessData = this.userService.getUsersAccessData();
        this.itemDept.DeptCode="";
        this.itemDept.DeptName="";
        if (data.calledFrom) {
            switch (data.calledFrom)
            {
              
                case "SalesReport":
                {
                  this.showTableForTransactionReport = true;
                  //this.itemDept.fromReport=true;
                  //this.itemDept.DeptCode=data.itemData.DeptCode
                  break;
                }
                default:{
    
                }
    
            }
        }
        this.searchDepartment();
    }

    ngOnInit(): void {
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.deptDataSource.data.length;
        return numSelected === numRows;
      }
    
      /** Selects all rows if they are not all selected; otherwise clear selection. */
      masterToggle() {
        this.isAllSelected() ?
          this.selection.clear() :
          this.deptDataSource.data.forEach(row => this.selection.select(row));
      }

      AllowOnlyNumber(event: any) {

        var inputValue = String.fromCharCode(event.keyCode);
        // Allow numbers, alpahbets, space, underscore
        if (/[0-9]/.test(inputValue)) {
          return true;
        } else {
          event.preventDefault();
          return false;
        }
      }

      pageChanged(event: PageEvent) {

        console.log({ event });
        this.pageSize = event.pageSize;
        this.currentPage = event.pageIndex;
        this.searchDepartment();
      }

      sendSelectedDept(deptData: any) {
        this.deptDialogService.close(deptData);//this will close the dialoge for item search and send the data to subscriber
      }

      sendSelectedDepts() {

        this.deptDialogService.close(this.selection.selected);//this will close the dialoge for item search and send the data to subscriber
      }

    @HostListener('keydown.enter', ['$event'])
    onEnterKey(event: KeyboardEvent) {
        this.searchDepartment();
    }

      searchDepartment() {


        // setting pagination request object 
        this.itemDept.NPINo = this.userAccessData.NPINo;
        this.itemDept.pagination.pageNumber = this.currentPage + 1;
        this.itemDept.pagination.pageSize = this.pageSize;

        this.deptArray=[];
       
        this.itemDeptService.getItemDeptWithPagination(this.itemDept).subscribe(response => {
    
          if (response.result == constant.KEY_SUCCESS) {
    
            if (response.data != "") {
              var receivedItemResponse = JSON.parse(response.data);
              this.deptArray = receivedItemResponse.itemData;
    
              if (this.deptArray.length < 1) {
                var alertRef = this.utilityService.showAlert(constant.KEY_WARNING, constant.ALERT_WARNING_TITLE, "No data found").subscribe(result => {
    
                  //if (result == true)
                  //this.dialogService.closeAll()
                  //NOT USING THE RESULT IF THE USER CLICKS ON BACKGROUND THEN RESULT WILL BE UNDEFINED
                });
    
                alertRef.unsubscribe();
                this.deptDataSource = new MatTableDataSource<any>(this.deptArray);
                this.deptDataSource.paginator = this.paginator!;
                this.deptDataSource.sort = this.sort!;
              } else {
                //for item table
                this.deptDataSource = new MatTableDataSource<any>(this.deptArray);
                this.deptDataSource.paginator = this.paginator!;
                this.deptDataSource.sort = this.sort!;
                
              
              }
    
    
              setTimeout(() => {
    
                this.paginator!.pageIndex = this.currentPage;
                this.paginator!.length = receivedItemResponse.totalRecords;
    
              });
            }
            else {
              var alertRef = this.utilityService.showAlert(constant.KEY_WARNING, constant.ALERT_WARNING_TITLE, "No data found").subscribe(result => {
    
                //if (result == true)
                //this.dialogService.closeAll()
                //NOT USING THE RESULT IF THE USER CLICKS ON BACKGROUND THEN RESULT WILL BE UNDEFINED
              });
    
              alertRef.unsubscribe();
              this.deptDataSource = new MatTableDataSource<any>(this.deptArray);
              this.deptDataSource.paginator = this.paginator!;
              this.deptDataSource.sort = this.sort!;
            }
    
    
    
          }
          else if (response.result == constant.KEY_ERROR) {
            if (response.message == "No data found") {
              this.deptDataSource = new MatTableDataSource<any>(this.deptArray);
                this.deptDataSource.paginator = this.paginator!;
                this.deptDataSource.sort = this.sort!;
              var alertRef = this.utilityService.showAlert(constant.KEY_WARNING, constant.ALERT_WARNING_TITLE, "No data found").subscribe(result => {
              });
            }
            else {
              this.deptDataSource = new MatTableDataSource<any>(this.deptArray);
                this.deptDataSource.paginator = this.paginator!;
                this.deptDataSource.sort = this.sort!;
              this.utilityService.showAlert(constant.KEY_ERROR, constant.ALERT_FAILED_TITLE, "Error while loading the items");
            }
          }
    
        });
      }

  }